import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import React from "react";

import ImageLink from "./ImageLink";
import OCRLink from "./OCRLink";

const CanvasDownloadLinks = ({canvas, label, sizes, t, manifestUrl}) => {
    const seeAlso = canvas.getProperty('seeAlso')
    const ocrTextFile = Array.isArray(seeAlso) &&  seeAlso != null ? seeAlso.find(item => item.format === 'text/plain') : null;

    return (
        <Card className="mb-3" raised style={{marginBottom: '16px'}}>
            <CardContent>
                <Typography component="h4" style={{textTransform: "none"}} variant="h4">
                    <Box fontWeight="fontWeightBold">{`${t("image")}: ${label}`}</Box>
                </Typography>
                <List>
                    {sizes
                        .sort((a, b) => b.width - a.width)
                        .slice(1)
                        .reduce(
                            (acc, {height, width}) => {
                                // only take sizes, where the difference between the last taken width
                                // and the current one is bigger than 500 pixels
                                if (acc[acc.length - 1].width - width >= 500) {
                                    acc.push({height, width});
                                }
                                return acc;
                            },
                            // this represents the full size
                            [{height: canvas.getHeight(), width: canvas.getWidth()}],
                        )
                        .map(({height, width}) => (
                            <ListItem dense key={`${height}x${width}`}>
                                <ImageLink
                                    height={height}
                                    linkTarget={canvas.getCanonicalImageUri(width)}
                                    t={t}
                                    width={width}
                                    label={label}
                                    manifestUrl={manifestUrl}
                                />
                            </ListItem>
                        ))}
                    {ocrTextFile && (
                        <ListItem dense key={`OCR`}>
                            <OCRLink linkTarget={ocrTextFile.id} label={label} t={t} manifestUrl={manifestUrl}></OCRLink>
                        </ListItem>
                    )}
                </List>
            </CardContent>
        </Card>
    );
};

CanvasDownloadLinks.defaultProps = {
    sizes: [],
};

CanvasDownloadLinks.propTypes = {
    canvas: PropTypes.shape({
        getCanonicalImageUri: PropTypes.func.isRequired,
        getHeight: PropTypes.func.isRequired,
        getWidth: PropTypes.func.isRequired,
    }).isRequired,
    label: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    sizes: PropTypes.arrayOf(
        PropTypes.shape({
            height: PropTypes.number.isRequired,
            width: PropTypes.number.isRequired,
        }),
    ),
    t: PropTypes.func.isRequired,
    manifestUrl: PropTypes.string.isRequired,
};

export default CanvasDownloadLinks;
